// React
import { FC, useState } from 'react'

// Libraries
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

// Custom
import { FORM, GENERAL } from 'locales'
import { FormContainer, FormSubTitle, FormTitle } from './styled'
import { MainButton } from 'components/UI/Buttons'
import { phoneMask, phoneRegex, removeSpecials } from 'utils/formatters'
import InputText from 'components/InputText'
import Modal from 'components/Modal'

export interface FormInputs {
  name: string
  email: string
  phone?: string
  message: string
}

const contactUsSchema = yup.object().shape({
  name: yup.string().required('Digite o nome'),
  email: yup.string().email('Email inválido').required('Digite o email'),
  phone: yup.string().matches(phoneRegex, 'Digite um número válido'),
  message: yup
    .string()
    .min(6, 'Mensagem muito curta')
    .required('Digite a mensagem'),
})

const Form: FC = () => {
  const [showModal, setShowModal] = useState(false)
  const { t } = useTranslation()

  const {
    getValues,
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<FormInputs>({
    resolver: yupResolver(contactUsSchema),
  })

  const toggleShowModal = () => {
    setShowModal(false)
  }

  const onSubmit = (data: FormInputs) => {
    setShowModal(true)
    data.phone = removeSpecials(data.phone)
    console.log(data)
    reset()
  }

  return (
    <FormContainer onSubmit={handleSubmit(onSubmit)}>
      <FormTitle>{t(FORM.title)}</FormTitle>
      <FormSubTitle>{t(FORM.subtitle)}</FormSubTitle>
      <InputText
        error={errors.name?.message}
        placeholder={t(FORM.name)}
        name={register('name').name}
        onChange={register('name').onChange}
        onBlur={register('name').onBlur}
        refName={register('name').ref}
        value={getValues('name')}
      />
      <InputText
        error={errors.email?.message}
        placeholder={t(FORM.email)}
        name={register('email').name}
        onChange={register('email').onChange}
        onBlur={register('email').onBlur}
        refName={register('email').ref}
        value={getValues('email')}
      />
      <InputText
        error={errors.phone?.message}
        maskFunction={phoneMask}
        placeholder={t(FORM.phone)}
        name={register('phone').name}
        onChange={register('phone').onChange}
        onBlur={register('phone').onBlur}
        refName={register('phone').ref}
        value={getValues('phone')}
      />
      <InputText
        error={errors.message?.message}
        type="textarea"
        placeholder={t(FORM.message)}
        name={register('message').name}
        onChange={register('message').onChange}
        onBlur={register('message').onBlur}
        refName={register('message').ref}
        value={getValues('message')}
      />
      <MainButton type="submit" data-testid="submit">
        {t(GENERAL.buttons.form)}
      </MainButton>
      <Modal type="success" show={showModal} onClose={toggleShowModal} />
    </FormContainer>
  )
}

export default Form
